export default (($) => {
    console.log('UNTUCKit : Module : DyEvents : loaded');
    /*
      * Analytics tracking for Dynamic Yield
      * Functions in the singular are called directly.
      * Functions as plurals are event bindings and are called on init.
      */
    /* SPA Events */
    function collectionSpaEvents() {
        if (window.DY === undefined)
            return;
        //Open QuickShop SPA Event
        $('.js-quick-shop').on('click', (e) => {
            const productSku = e.target.getAttribute("data-product-sku");
            const productUrl = e.target.getAttribute("data-product-url");
            const spaPropsObject = {
                context: {
                    type: 'PRODUCT',
                    data: [productSku ? productSku : "N/A"],
                },
                url: productUrl ? productUrl : "N/A",
            };
            console.log('SPA Object', spaPropsObject);
            window.DY.API('spa', spaPropsObject);
        });
        //Close Inline Cart SPA Event
        $('.js-close-cart').on('click', () => {
            prodToCollection();
        });
        //Close QuickShop Btn SPA Event
        $('.js-quick-shop-close').on('click', () => {
            prodToCollection();
        });
        //Close QuickShop Overlay SPA Event
        $('.overlay').on('click', () => {
            /* check to see if we are on a collections page */
            if ($('.quick-shop').hasClass('is-active')) {
                prodToCollection();
            }
            return true;
        });
    }
    //SpaEvent Product to Collection Link
    function prodToCollection() {
        if (window.DY === undefined)
            return;
        const collection = window.collectionTitle || "Page N/A";
        const collectionUrl = window.location.href ? window.location.href : "N/A";
        const spaPropsObject = {
            context: {
                type: 'CATEGORY',
                data: [collection],
            },
            url: collectionUrl,
        };
        console.log('SPA Object', spaPropsObject);
        window.DY.API('spa', spaPropsObject);
    }
    /**
     * Event bindings for filter actions
     */
    function filterEvents() {
        if (window.DY === undefined)
            return;
        $(document).on('click', '.bc-sf-filter-option-item ', (event) => {
            const $target = $(event.currentTarget);
            const filterName = $target.attr('data-parent-label');
            const filterValue = $target.attr('data-title');
            console.log('target', $target, 'filterName', filterName, 'filterValue', filterValue);
            window.DY.API('event', {
                name: 'Filter Items',
                properties: {
                    dyType: 'filter-items-v1',
                    filterType: filterName,
                    filterStringValue: filterValue,
                },
            });
        });
    }
    const loginEvent = (email) => {
        if (window.DY === undefined)
            return;
        const $email = email;
        window.DY.API('event', {
            name: 'Login',
            properties: {
                dyType: 'login-v1',
                hashedEmail: $email,
            },
        });
        console.info('Dynamic Yield Event Fired: Account_Login');
    };
    /* Click-through PDP DY Event */
    function clickThroughEvent() {
        if (window.DY === undefined)
            return;
        $(document).on("click", ".product-grid-item", function (e) {
            clickThroughPdp(e);
        });
        function clickThroughPdp(event) {
            const $target = $(event.currentTarget);
            const $price = $target.data('price');
            window.DY.API('event', {
                name: 'click-through-rate-pdp',
                properties: {
                    value: $price ? $price : 0,
                    trigger: $target,
                    price: $price ? $price : 0
                },
            });
        }
    }
    /*
       * Init DY functions and bind required events
       */
    function init() {
        console.log('UNTUCKit : Module : DyEvents : init');
        collectionSpaEvents();
        clickThroughEvent();
        filterEvents();
        if (window.location.search.substring(1) === 'logged-in=true') {
            loginEvent(localStorage.getItem('userEmail'));
        }
    }
    return {
        init
    };
})($);
